module.exports = __webpack_public_path__ + "img/finance.dbc6a7da.svg";